import { render, staticRenderFns } from "./Pubzb.vue?vue&type=template&id=a1533484&"
import script from "./Pubzb.vue?vue&type=script&lang=js&"
export * from "./Pubzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports